<template>
  <v-btn
    fab
    small
    color="primary"
    class="elevation-3"
    @click="evt => $emit('click', evt)"
    v-on="on"
  >
    <slot>
      <app-icon>add</app-icon>
    </slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    on: { type: Object, default: null }
  }
}
</script>
